
import { Drawer } from "element-ui"
import dayjs from "dayjs"
import _ from "lodash"
import {
  getOrderDetails,
  getOrderEstampDetails,
  deleteOrder,
  buyAgain,
  cancelOrder,
  getCancelReason,
  getRelatedOrderList,
  cancelOrderAfterPaid,
  getReceipt
} from "@/api/order"
import { tooltipCustomStyle, generateQR, formatWareImgUrl } from "@/utils/utils"
import getCartNumMixin from "@/mixins/getCartNum"
import step from "@/components/order/step.vue"
import ware from "@/components/order/ware.vue"
import checkout from "@/components/order/checkoutInfo.vue"
import vendorInfo from "@/components/order/vendorInfo.vue"
import stamp from "@/components/order/stamp.vue"
import tooltip from "@/components/tooltip.vue"
import drawerHeader from "@/components/drawer/components/drawerHeader.vue"
import countDown from "@/components/order/countDown.vue"
import OfflinePaymentCountDown from "@/components/order/offlinePaymentCountDown.vue"
import { getRootStyle } from "@/utils/head"
import { createQrPolling } from "@/utils/qrCodePolling"

export default {
  components: {
    step,
    ware,
    checkout,
    vendorInfo,
    stamp,
    tooltip,
    drawerHeader,
    countDown,
    OfflinePaymentCountDown,
    [Drawer.name]: Drawer
  },
  mixins: [getCartNumMixin],
  props: {},
  data() {
    return {
      lang: this.$i18n.locale,
      breadcrumbData: [],
      orderId: null,
      orderDetails: {},
      orderVendorInfo: [],
      orderEstampInfo: {},
      orderStatusSvg: "info",
      stepInfo: [],
      wareInfo: {},
      checkoutInfo: [],
      loadingInstance: null,
      hadRequest: false,
      signatureVisable: false,
      signatureTitle: this.$t("orderDetails.checkSignature"),
      curVisible: false,
      reasonOptions: [],
      reason: "",
      cancelTitle: this.$t("orderDetails.cancelReason"),
      relationVisable: false,
      relationTips: "",
      relationTitle: this.$t("orderDetails.cancelOrder"),
      relationBtnText: this.$t("orderDetails.cancelAll"),
      relationOrderList: [],
      reasonPlaceholder: this.$t("orderDetails.reasonPlaceholder"),
      yuuId: "",
      cancelBtnText: this.$t("orderDetails.confirm"),
      btnDisabled: true,

      showQRcode: false,
      showQRcodeSrc: "",
      showOfflineQRcodeSrc: "", // 线下支付二维码
      qrPolling: null,
      showOrderTracking: false,
      orderTrackingTitle: this.$t("orderDetails.orderTracking"),
      orderStatusDes: "",
      showQRcasherTitle: false
    }
  },
  computed: {
    isShowOfflineQRcode() {
      return this.orderDetails?.orderTagObj?.preOrderOfflinePaymentFlag === 1 && this.orderDetails?.orderStatus === 1
    },
    isOfflinePaymentType() {
      return this.orderDetails?.orderTagObj?.preOrderOfflinePaymentFlag === 1
    }
  },
  watch: {},
  async created() {},
  async mounted() {
    document.title = this.$t("pageTitle.order_details")
    await this.init()
  },
  beforeDestroy() {
    this.qrPolling?.stop()
  },
  methods: {
    dayjs,
    tooltipCustomStyle(index) {
      return tooltipCustomStyle(index)
    },
    translate(name) {
      return this.$t(name)
    },
    init() {
      this.initBreadcrumb()
      this.hadRequest = false
      const { orderId } = this.$route.query
      this.orderId = orderId
      this.getOrderdDetailsFun()
      this.getOrderdEstampFun()
    },
    initBreadcrumb() {
      const whereFrom = {
        name: this.$t("common.home"),
        path: this.MAIN_PATH_WITHOUT_LANG
      }
      const selPath = [{ name: this.$t("common.orderDetails") }]

      console.log("selPath ", selPath)
      this.breadcrumbData = [whereFrom, ...selPath]
    },
    breadcrumbClick(item) {},
    async getOrderdDetailsFun() {
      try {
        this.hadRequest = false
        const { data } = await getOrderDetails({
          param: {
            orderId: this.orderId
          }
        })
        if (data) {
          this.orderDetails = data
        }
        const frontOrderVO = this.mapStatus(this.orderDetails.frontOrderVO)
        this.orderDetails = { ...this.orderDetails, ...frontOrderVO }
        this.wareInfo = this.orderDetails.frontOrderVO
        this.checkoutInfo = this.orderDetails.frontOrderVO && this.orderDetails.frontOrderVO.orderItemList
        this.orderVendorInfo = this.orderDetails?.frontOrderVO?.supplierInfo || []
        this.yuuId = this.orderDetails.frontOrderVO && this.orderDetails.frontOrderVO.anfieldUserId
        this.stepInfo =
          (this.orderDetails.frontOrderVO.orderTrackingVO &&
            this.orderDetails.frontOrderVO.orderTrackingVO.operations) ||
          []
        this.orderStatusDes = this.stepInfo[this.stepInfo.length - 1]
          ? this.stepInfo[this.stepInfo.length - 1].frontEndDesc
          : ""
        // 已完成 &&  ready to pick up 显示QRcode
        if ([13].includes(this.orderDetails.orderStatus)) {
          this.showQRcasherTitle = true
        }
        if ([4, 5, 13].includes(this.orderDetails.orderStatus)) {
          this.showQRcode = true
          const selfPickupCode = this.orderDetails?.frontOrderVO?.orderTagObj?.selfPickupCode
          if (selfPickupCode) {
            generateQR(selfPickupCode).then(src => {
              this.showQRcodeSrc = src
            })
          }
        }
        // offline payment线下支付
        if (this.orderDetails?.orderTagObj?.preOrderOfflinePaymentFlag === 1) {
          if (this.orderDetails?.offlinePaymentOrderInfo) {
            this.generateOfflineQrCode(this.orderDetails.offlinePaymentOrderInfo)
          }
          if (this.orderDetails?.orderStatus === 1) {
            this.generateQrPolling()
          }
        }
      } catch (error) {
        console.log(error)
      } finally {
        this.hadRequest = true
      }
    },
    getOrderdEstampFun() {
      getOrderEstampDetails({
        param: JSON.stringify({
          orderId: this.orderId
        })
      }).then(res => {
        if (res.code === "0000") {
          this.orderEstampInfo = res.data || {}
        }
      })
    },
    mapStatus(item) {
      const { primaryColor, progressSuccessColor } = getRootStyle()
      item.orderStatusSvg = "info"
      item.orderStatusSvgBIg = "warning"
      item.orderStatusColor = "#000"
      // 待支付1
      if ([1].includes(item.orderStatus)) {
        item.orderStatusSvg = "info"
        item.orderStatusColor = primaryColor
        item.orderStatusSvgColor = primaryColor
      }
      // 已支付 9 等待生產16
      if ([9, 16].includes(item.orderStatus)) {
        item.orderStatusSvg = "coin"
        item.orderStatusSvgBIg = "paid"
        item.orderStatusColor = primaryColor
        item.orderStatusSvgColor = primaryColor
      }
      // 生產中,揀貨中 10
      if ([10].includes(item.orderStatus)) {
        item.orderStatusSvg = "note"
        item.orderStatusSvgBIg = "preparingYourOrder"
        item.orderStatusColor = primaryColor
        item.orderStatusSvgColor = primaryColor
      }
      // 拣货完成14
      if ([14].includes(item.orderStatus)) {
        item.orderStatusSvg = "box"
        item.orderStatusSvgBIg = "readyForDelivery"
        item.orderStatusColor = primaryColor
        item.orderStatusSvgColor = primaryColor
      }
      // 送貨中 12
      if ([12].includes(item.orderStatus)) {
        item.orderStatusSvg = "deliveryCarLeft"
        item.orderStatusSvgBIg = "deliveryCarRightBig"
        item.orderStatusColor = primaryColor
        item.orderStatusSvgColor = primaryColor
      }
      // 已完成4 ,自提已完成5
      if ([4, 5].includes(item.orderStatus)) {
        item.orderStatusSvg = "complete"
        item.orderStatusSvgBIg = "completed"
        item.orderStatusColor = progressSuccessColor
      }

      // 訂單取消 6
      if ([6].includes(item.orderStatus)) {
        item.orderStatusSvg = "closeCircle"
        item.orderStatusSvgBIg = "cancelled"
        item.orderStatusColor = "#969696"
      }
      // 待自提 13
      if ([13].includes(item.orderStatus)) {
        item.orderStatusSvg = "readytopickup"
        item.orderStatusSvgBIg = "readytopickupBig"
        item.orderStatusColor = progressSuccessColor
        item.orderStatusSvgColor = progressSuccessColor
      }

      // 延迟配送
      if (item.orderTagObj.shipmentDelay && item.orderTagObj.shipmentDelay === 2) {
        if (item.orderStatus !== 13) {
          item.orderStatusColor = "#ED752F"
          item.orderStatusSvgBIg = "shipmentDelay"
        }
      }
      return item
    },

    handleCopy: _.debounce(function (orderId) {
      this.$copyText(String(orderId)).then(res => {
        this.$message({ message: this.$t("orderDetails.copySuccess"), type: "success", duration: 1000 })
      })
    }, 500),
    fen2Yuan(num) {
      if (isNaN(num)) return ""
      num = Number(num)
      return (num / 100).toFixed(2)
    },

    getNumber(nums) {
      if (isNaN(nums)) return ""
      const num = this.fen2Yuan(nums)
      const str = num.toString()
      const res = str.split(".")
      return res[0]
    },
    getSmallNumber(nums) {
      if (isNaN(nums)) return ""
      const num = this.fen2Yuan(nums)
      const str = num.toString()
      const res = str.split(".")
      return res.length === 2 ? res[1] : ""
    },
    handleCheckSignature() {
      this.signatureVisable = true
    },
    handleClose() {
      this.signatureVisable = false
    },
    handleRelationClose() {
      this.relationVisable = false
    },
    handleRelationSave() {
      this.relationVisable = false
      this.curVisible = true
    },
    handleReasonClose() {
      this.curVisible = false
      this.reason = ""
      this.btnDisabled = true
    },
    async handleReasonSave() {
      // if (!this.reason) {
      //   this.$message({ message: "Please Make a choice", type: "warning" })
      //   return
      // }
      this.curVisible = false
      try {
        const orderStatus = this.orderDetails.frontOrderVO.orderStatus
        if (orderStatus == 1) {
          // 支付前cancel
          const res = await cancelOrder({
            param: JSON.stringify({
              causeContent: this.reason.dictName,
              causeId: this.reason.id,
              orderId: this.orderId
            })
          })
          if (res && res.data) {
            this.$message({ message: this.$t("orderDetails.cancelOrderSuccess"), type: "success" })
            setTimeout(() => {
              window.location.reload()
            }, 500)
          }
        } else {
          // 支付后cancel
          const res = await cancelOrderAfterPaid({
            param: JSON.stringify({
              causeContent: this.reason.dictName,
              causeId: this.reason.id,
              orderId: this.orderId
            })
          })
          if (res && res.data) {
            this.$message({ message: this.$t("orderDetails.cancelOrderSuccess"), type: "success" })
            setTimeout(() => {
              window.location.reload()
            }, 500)
          }
        }
      } catch (error) {
        console.log(error)
      }
    },
    handleReasonSel(item) {
      this.reasonOptions = this.reasonOptions.map(x => {
        x.isActive = false
        if (item.id == x.id) {
          x.isActive = true
          this.reason = item
          this.btnDisabled = !this.reason
        }
        return x
      })
      this.handleReasonSave()
    },
    async handleBtnClick(it) {
      // it.btnTag = 12
      // 11, "立即支付"
      if (it.btnTag == 11) {
        if (
          this.orderDetails.frontOrderVO.orderTagObj &&
          this.orderDetails.frontOrderVO.orderTagObj.relatedOrderIds &&
          this.orderDetails.frontOrderVO.orderTagObj.relatedOrderIds.length >= 2
        ) {
          this.$messageBox
            .open({
              title: "",
              message: this.$t("orderDetails.pendingPaymentTips"),
              cancelText: this.$t("orderDetails.cancel"),
              confirmText: this.$t("orderDetails.confirmP")
            })
            .then(() => {
              this.$navigation.push({
                path: "/pending_payment",
                query: {
                  orderNo: this.orderDetails.frontOrderVO.orderId,
                  venderId: this.orderDetails.frontOrderVO.venderId
                }
              })
            })
            .catch(res => {
              console.log(res)
            })
        } else {
          this.$navigation.push({
            path: "/pending_payment",
            query: {
              orderNo: this.orderDetails.frontOrderVO.orderId,
              venderId: this.orderDetails.frontOrderVO.venderId
            }
          })
        }
      }
      // 91 取消订单
      if (it.btnTag == 91) {
        const orderStatus = this.orderDetails.frontOrderVO.orderStatus
        this.reason = ""
        try {
          const res = await getCancelReason({
            param: JSON.stringify({
              dictCodeL1: "4",
              dictCodeL2: "1",
              tradeType: 1
            })
          })
          const { cancelReasons } = res.data
          if (cancelReasons) {
            this.reasonOptions = cancelReasons
          }

          // 待支付 支付前
          if (orderStatus == 1) {
            console.log("支付前cancel")
            if (
              this.orderDetails.frontOrderVO.orderTagObj &&
              this.orderDetails.frontOrderVO.orderTagObj.relatedOrderIds &&
              this.orderDetails.frontOrderVO.orderTagObj.relatedOrderIds.length >= 2
            ) {
              this.$messageBox
                .open({
                  title: "",
                  message: this.$t("orderDetails.ordersFromDifferentStores"),
                  cancelText: this.$t("orderDetails.cancel"),
                  confirmText: this.$t("orderDetails.confirmO")
                })
                .then(() => {
                  this.curVisible = true
                })
                .catch(res => {
                  console.log(res)
                })
            } else {
              this.curVisible = true
            }
          } else {
            // 支付后
            console.log("支付后cancel")
            try {
              const res = await getRelatedOrderList({
                param: JSON.stringify({
                  orderId: this.orderDetails.frontOrderVO.orderId,
                  tradeType: 1
                })
              })
              const { extInfo, allBrotherOrder } = res.data
              if (allBrotherOrder && allBrotherOrder.length) {
                this.relationTips = extInfo && extInfo.content
                this.relationOrderList = allBrotherOrder
                this.relationVisable = true
              } else {
                this.curVisible = true
              }
            } catch (error) {
              console.log(error)
            }
          }
        } catch (error) {
          console.log(error)
        }
      }
      // contact us
      if (it.btnTag == 21) {
        const contactUsLink = this.$t("footer.contactUsLink")
        window.open(contactUsLink)
      }
      // buy again
      if (it.btnTag == 61) {
        try {
          const res = await buyAgain({
            param: JSON.stringify({
              sort: 1,
              orderId: this.orderDetails.frontOrderVO.orderId
            })
          })
          const { message, showBtn } = res.data
          if (message) {
            this.$messageBox
              .open({
                title: this.$t("orderDetails.buyAgain"),
                message,
                cancelText: this.$t("orderDetails.stayHere"),
                confirmText: this.$t("orderDetails.goToCart"),
                showButton: showBtn
              })
              .then(res => {
                this.$navigation.push({ path: "/cart" })
              })
              .catch(res => {
                console.log(res)
              })
          }
        } catch (error) {
          console.log("buy again failed", error)
        }
      }

      // delete order
      if (it.btnTag == 81) {
        this.$messageBox
          .open({
            title: this.$t("orderDetails.deleteOrder"),
            message: this.$t("orderDetails.deleteOrderTips"),
            cancelText: this.$t("orderDetails.deleteOrder"),
            confirmText: this.$t("orderDetails.cancel")
          })
          .then(res => {})
          .catch(async res => {
            try {
              const result = await deleteOrder({
                param: JSON.stringify({
                  orderId: this.orderId
                })
              })
              this.$message({ message: this.$t("orderDetails.deleteOrderSuccess"), type: "success" })
              setTimeout(() => {
                this.$navigation.push({
                  path: "/order_list",
                  query: {
                    page: 1
                  }
                })
              }, 1000)
            } catch (error) {
              console.log(error)
            }
          })
      }
      // 查看收据 ？？
      if (it.btnTag == 96 || it.btnTag == 97) {
        /// / todo
        this.handleReceipt()
      }
      // 联络我们的送货员
      if (it.btnTag == 56) {
        const deliveryManPhone = this.orderDetails.frontOrderVO.deliveryManPhone || ""
        this.$messageBox
          .open({
            title: this.$t("orderDetails.contactOurDeliveryMan"),
            message: this.$t("address.phone") + ":" + deliveryManPhone,
            confirmText: this.$t("common.confirm"),
            showCancel: false
          })
          .then(res => {})
          .catch(async res => {})
      }
      // pick up with QR
      if (it.btnTag == 98) {
        this.showQR = true
        const selfPickupCode = this.curClickOrderItem?.orderTagObj?.selfPickupCode
        if (selfPickupCode) {
          generateQR(selfPickupCode).then(src => {
            this.showQRcodeSrc = src
          })
        }
      }
    },
    handleChange(data) {
      console.log(data)
    },

    handleReceipt() {
      window.open(
        `${this.MAIN_ORIGIN}${this.MAIN_PATH}/receipt?orderId=${this.orderDetails.frontOrderVO.orderId}`,
        "_blank"
      )
    },
    getTootipContent(list) {
      const { childTicketList = [], remarkList = [] } = list
      if (childTicketList && childTicketList.length) {
        const result = childTicketList.map(
          (item, index) => `<div style="display: flex;justify-content: space-between;margin-top: ${
            index === 0 ? "0" : "0.16rem"
          };">
              <span>${item.smallTicketLineName}</span>
              <span>${item.smallTicketLinePriceWithSymbol}</span></div>`
        )

        return result
      }

      return remarkList || []
    },
    formatWareImgUrl,
    requestOfflineOrderData(isLoading = false) {
      return getOrderDetails(
        {
          param: { orderId: this.orderId }
        },
        isLoading
      ).then(res => {
        return res.data || {}
      })
    },
    generateQrPolling() {
      this.qrPolling = createQrPolling({
        getQrField(res) {
          return res.qrCode
        },
        request: () => {
          return this.requestOfflineOrderData(false)
        },
        isSuccess: res => {
          return res?.frontOrderVO?.orderStatus === 9 // 9:支付成功
        },
        onError(err) {
          console.log("onError", err)
        }
      })
      this.qrPolling?.start()
    },
    async generateOfflineQrCode(qrUrl = "") {
      if (!qrUrl) return
      try {
        this.showOfflineQRcodeSrc = await generateQR(qrUrl)
      } catch (err) {
        console.error("轮询/生成二维码失败：", err)
      }
    },
    handleShowOrderTracking() {
      this.showOrderTracking = true
    },
    handOrderTrackingleClose() {
      this.showOrderTracking = false
    }
  }
}
